import React, { useEffect, useState } from "react";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { BHAREE_BASE_URL_LOCAL } from "../../../config/config.url";
import PageSpinner from "../../common/PageSpinner";
import UserLP from "../AdminPanelBharee/UsersList/UserLP";
import { Tab, Tabs, Container } from "react-bootstrap";
import VehicleInfo from "../AdminPanelBharee/UsersList/VehicleInfo";
import UserBankingInfo from "../AdminPanelBharee/UsersList/UserBankingInfo";
import "./index.css";

const LPSettings = () => {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [userObj, setUserObj] = useState(null);
  const [tabKey, setTabKey] = useState("companyInfo");

  const { auth, requestCall } = useSelector((state) => {
    return state;
  });

  useEffect(() => {
    console.log("Auth Details LP: ", auth);
    getLPDetails();
  }, []);

  const getLPDetails = async () => {
    setLoading(true);
    try {
      const response = await axios.get(BHAREE_BASE_URL_LOCAL + "/logistics/" + auth?.user?.id, {
        headers: {
          Authorization: `Bearer ${localStorage.jwtToken}`,
        },
      });
      console.log("getLPDetails: ", response);
      if (response && response?.data) {
        if (response?.data?.success) {
          setUserObj(response?.data?.data);
        }
      }
      return response;
    } catch (error) {
      console.error("Upload error:", error.response || error.message);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <PageSpinner />}
      {userObj !== null && (
        <Container className="bhree-admin-user-list p-0">
          <Tabs id="offer-tabs" activeKey={tabKey} onSelect={(k) => setTabKey(k)} className="mb-0">
            <Tab eventKey="companyInfo" title={`User & Main Vehicle Info`}>
              <UserLP userId={userObj.id} propUserObj={userObj} />
            </Tab>
            {/* <Tab eventKey="vehicleInfo" title={`Other Vehicles`}>
              <VehicleInfo userId={userObj.id} />
            </Tab>*/}
            <Tab eventKey="bankingInfo" title={`Banking Info`}>
              <UserBankingInfo userId={userObj.id} userObj={userObj} />
            </Tab>
          </Tabs>
        </Container>
      )}
    </>
  );
};

export default LPSettings;
